import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const StudentsScoringAboveInAssessments = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Students scoring above 70% in assessments (%)" />
    </Box>
  );
};
